export default __webpack_public_path__ + "static/media/map-europe.9ebdf36e.jpg";